'use client';

import { jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { createPortal } from "react-dom";
import { ChalkThemeContext } from "../../themes/ChalkThemeProvider/ChalkThemeProvider.context.js";
import { ChalkThemeProvider } from "../../themes/ChalkThemeProvider/ChalkThemeProvider.js";
function ChalkPortal({
  children: childrenProp,
  element: elementProp
}) {
  const { bodyFont, primaryColor, titleFont } = useContext(ChalkThemeContext);
  const element = elementProp || globalThis?.document?.body;
  const hasThemes = !!bodyFont || !!primaryColor || !!titleFont;
  let children = childrenProp;
  if (hasThemes) {
    children = /* @__PURE__ */ jsx(
      ChalkThemeProvider,
      {
        bodyFont,
        primaryColor,
        titleFont,
        children: childrenProp
      }
    );
  }
  if (!element) return null;
  return createPortal(children, element);
}
export {
  ChalkPortal
};
